// extracted by mini-css-extract-plugin
export default {"root":"SyncWithPartner_root__weN3O","button":"SyncWithPartner_button__oDkko","lastSync":"SyncWithPartner_lastSync__9tUke"};